// import hooks
import PhoneInput, { CountryData } from "react-phone-input-2";
// import { useState } from "react";

// import components

// import assets
import "react-phone-input-2/lib/style.css";

// import data
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import { InputProps } from "./Input";

const CustomPhoneInput = ({
    value,
    handleChange,
    label = "Phone",
    error,
    className,
    style
}: InputProps) => {
    const onHandleChange = (e: string, val: {} | CountryData) => {
        const contactno = e?.slice(
            (val as CountryData)?.dialCode.length,
            e.length
        );
        const dialCode = (val as CountryData)?.dialCode;
        handleChange(e, contactno, dialCode, val as CountryData);
    };

    const location = useSelector((state: RootState) => state.site.location);

    return (
        <div className={`field custom-phone-input ${className}`} style={style}>
            <label>{label}</label>
            <div className="control">
                <PhoneInput
                    country={location ? location.toLowerCase() : ""}
                    value={value}
                    onChange={onHandleChange}
                    enableAreaCodes={false}
                />
            </div>
            <p className={`field-error ${error ? "" : "is-hidden"}`}>{error}</p>
        </div>
    );
};

export default CustomPhoneInput;
